import { render, staticRenderFns } from "./bankLists.vue?vue&type=template&id=58261271"
import script from "./bankLists.vue?vue&type=script&lang=js"
export * from "./bankLists.vue?vue&type=script&lang=js"
import style0 from "./bankLists.vue?vue&type=style&index=0&id=58261271&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports